import React, { useCallback, useState } from 'react'
import { validateOptionalBannoOAuthRedirectUrlBase } from '@ecountabl/lib'

type Props = {
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const BannoRedirectUrlBaseField = ({ value, onChange }: Props) => {
  const [error, setError] = useState<string | null>(null)

  const handleBlur = useCallback(() => {
    const result = validateOptionalBannoOAuthRedirectUrlBase(value)
    setError(result.ok === false ? result.message : null)
  }, [value])

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setError(null)
      onChange(event)
    },
    [onChange]
  )

  const redirectBaseTooltip =
    'Must match a redirect URI allowed in Jack Henry for this external app. Use your public API origin only (scheme + host, no path). Leave blank to use the incoming request host (same idea as Finastra OAuth).'

  return (
    <div className="form-group">
      <div className="d-flex align-items-center flex-wrap mb-1" style={{ gap: '0.35rem' }}>
        <label htmlFor="bannoRedirectUrlBase" className="mb-0">
          OAuth redirect URL base (optional)
        </label>
        <button
          type="button"
          className="btn btn-link p-0 m-0 align-baseline text-muted"
          title={redirectBaseTooltip}
          aria-label={redirectBaseTooltip}
          style={{ fontSize: '0.95em', lineHeight: 1, cursor: 'help' }}
        >
          <i className="fa fa-info-circle" aria-hidden />
        </button>
      </div>
      <input
        id="bannoRedirectUrlBase"
        name="bannoRedirectUrlBase"
        type="text"
        className={`form-control${error ? ' is-invalid' : ''}`}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        autoComplete="off"
        placeholder="e.g. https://api.example.com"
      />
      {error ? (
        <div className="invalid-feedback d-block" role="alert">
          {error}
        </div>
      ) : null}
    </div>
  )
}

export default BannoRedirectUrlBaseField
